import { TOOLBAR_HEIGHT } from '../../constants/Dimensions';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDetailHeaderStyles = (theme, additionalStyles) => Object.assign({
  blockSize: `${TOOLBAR_HEIGHT}px`,
  borderBlockEndColor: theme.color['border-core-subtle'],
  borderBlockEndStyle: 'solid',
  borderBlockEndWidth: theme.borderWidth[100],
  backgroundColor: theme.color['fill-surface-default'],
  flexShrink: 0,
  zIndex: 1
}, additionalStyles);
const DetailHeaderWrapper = props => /*#__PURE__*/_jsx(Flex, Object.assign({
  backgroundColor: "fill-surface-default",
  blockSize: `${TOOLBAR_HEIGHT}px`,
  borderBlockEndColor: "border-core-subtle",
  borderBlockEndStyle: "solid",
  borderBlockEndWidth: "100",
  flexShrink: 0
}, props));
DetailHeaderWrapper.displayName = 'DetailHeaderWrapper';
export default DetailHeaderWrapper;